import { useEffect, useState } from 'react';
import { SFuncModal } from 'shj-components';
import { Form, message, Select } from 'antd';
import { useRequest } from "ahooks";
import { findProjectExternalEmployeeList, qualityMoneyConfigSave } from "@/services/qualityMoneyAccount.ts";

const { Option } = Select;

export function addFn({ fn, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: '补充账户',
        width: 500,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
    const [form] = Form.useForm();
    const [companyList, setCompanyList] = useState<any>([]);
    const [vendorList, setVendorList] = useState<any>([]);
    const [employeeList, setEmployeeList] = useState<any>([])
    let { loading: saveLoading, runAsync: runAsyncSave } = useRequest(qualityMoneyConfigSave, { manual: true });
    let { loading: queryLoading,runAsync: runAsyncQuery } = useRequest(findProjectExternalEmployeeList, { manual: true });

    useEffect(() => {
        runAsyncQuery({
            data: {
                userCodeOrName: '',
                labelFlag: false
            }
        }).then((res) => {
            setEmployeeList(res);
        })

    }, []);

    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            runAsyncSave({ data: { ...values, isEntry: false } }).then((res: any) => {
                if (res) {
                    message.error(res)
                    return
                } else {
                    message.success('新增成功');
                    onClose();
                    fn && fn();
                }
            })
        })

    };

    const closeModal = () => {
        onClose();
    };


    const reqMeg = '不能为空';
    const formItemLayout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 24 },
    };
    const chooseEmployee = (value, data) => {
        setCompanyList([])
        setVendorList([])
        const values = form.getFieldsValue();
        form.setFieldsValue({
            ...values,
            companyId: '',
            vendorId: '', 
          })
        runAsyncQuery({
            data: {
                userCodeOrName: data?.key.split(" ")[0],
                labelFlag: false
            }
        }).then((res: any) => {
            let companyList: any = [];
            let vendorList: any = [];
            res.forEach((item: any) => {
                companyList = companyList.concat(item?.companys)
                vendorList = item?.vendorInfos ? vendorList.concat(item?.vendorInfos) : vendorList
            })
            setCompanyList(companyList)
            setVendorList(vendorList)
        })
    }
    return (
        <div>
            <SFuncModal.Content
                onCancel={closeModal}
                onOk={onFinish}
                confirmLoading={saveLoading}>
                <Form 
                layout="vertical"
                form={form}>
                    <Form.Item
                        label="人员"
                        name="extEmpId"
                        {...formItemLayout}
                        rules={[{ required: true, message: reqMeg }]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            filterOption={(input: any, option: any) => {
                                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            optionFilterProp="children"
                            onChange={chooseEmployee}
                            loading={queryLoading}
                        >
                            {employeeList &&
                                employeeList.map((item, index) => (
                                    <Option key={`${item.name} ${index}`} value={item.id}>
                                        {`${item.name} (${item.phone})`}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="门店"
                        name="companyId"
                        rules={[{ required: true, message: reqMeg }]}
                        {...formItemLayout}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            filterOption={(input: any, option: any) => {
                                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            optionFilterProp="children"
                        >
                            {companyList &&
                                companyList.map((item, index) => (
                                    <Option key={item.id} value={item.orgId}>
                                        {item.name}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="承包商"
                        name="vendorId"
                        {...formItemLayout}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            filterOption={(input: any, option: any) => {
                                return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            optionFilterProp="children"
                        >
                            {vendorList &&
                                vendorList.map((item, index) => (
                                    <Option key={index} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                </Form>
            </SFuncModal.Content>
        </div>
    );
};
